import services from '@/services/ConfiguracaoRastreabilidadeService';

export function cadastrarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const params = {
        id: null,
        aplicarEstado: false,
        aplicarTodoEstado: true,
        excecoes: [],
        idEstado: null,
        idFornecedor: null,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'PADRAO'
    };

    return services.cadastrarConfiguracaoRastreabilidade(params);
}
export function editarParametros(configuracao) {
    const percentualCapacidadeProdutiva =
        configuracao.percentualCapacidadeProdutiva
            ? configuracao.percentualCapacidadeProdutiva
            : 15;
    const params = {
        id: configuracao.id,
        aplicarEstado: false,
        aplicarTodoEstado: true,
        idFornecedor: null,
        excecoes: [],
        idEstado: configuracao.idEstado,
        idMunicipio: null,
        distanciaRaioKm: configuracao.distanciaRaioKm,
        percentualCapacidadeProdutiva,
        tipoCadastro: 'PADRAO'
    };

    return services.editarConfiguracaoRastreabilidade(params);
}
